"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./style.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CheckboxAndRadio = function CheckboxAndRadio(_ref) {
  var name = _ref.name,
      id = _ref.id,
      value = _ref.value,
      label = _ref.label,
      checked = _ref.checked,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      type = _ref.type;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "Checkbox"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type || 'checkbox',
    className: "Checkbox__input",
    name: name,
    id: id,
    value: value,
    checked: checked,
    onChange: onChange,
    disabled: disabled
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: "icon-before icon-checkmark"
  }, label));
};

var _default = CheckboxAndRadio;
exports.default = _default;